import { TimeCard } from '../../../../api/models/timecard.model'
import { notUndefined } from '../../../common/utils/conditional-assert'
import { Utils } from '../../../common/utils/utils'

export class TimeCardContainer extends TimeCard {
    name?: string
    icon?: string
    colorByGroupBy?: string
    isExpanded?: boolean
    indentLvl?: number
    hoursToCharge?: string
    hoursNoCharge?: string
    hoursTotal?: string
    daysToCharge?: string
    daysNoCharge?: string
    daysTotal?: string
    parent: TimeCardContainer | undefined
    children: Array<TimeCardContainer> | undefined

    constructor(name?: string, icon?: string, colorByGroupBy?: string, children?: Array<TimeCardContainer>) {
        super()
        this.name = name
        this.icon = icon
        this.colorByGroupBy = colorByGroupBy
        this.children = children
    }
}

export const setTotals = (timesheetContainer: TimeCardContainer): void => {
    timesheetContainer.secondsNoInvoice = 0
    timesheetContainer.secondsToInvoice = 0
    notUndefined(timesheetContainer.children).forEach((child) => {
        timesheetContainer.secondsToInvoice += child.secondsToInvoice
        timesheetContainer.secondsNoInvoice += child.secondsNoInvoice
    })

    timesheetContainer.hoursToCharge = Utils.secondsAsHours(timesheetContainer.secondsToInvoice)
    timesheetContainer.hoursNoCharge = Utils.secondsAsHours(timesheetContainer.secondsNoInvoice)
    timesheetContainer.hoursTotal = Utils.secondsAsHours(
        timesheetContainer.secondsNoInvoice + timesheetContainer.secondsToInvoice
    )
    timesheetContainer.daysToCharge = Utils.secondsAsWorkingDay(timesheetContainer.secondsToInvoice)
    timesheetContainer.daysNoCharge = Utils.secondsAsWorkingDay(timesheetContainer.secondsNoInvoice)
    timesheetContainer.daysTotal = Utils.secondsAsWorkingDay(
        timesheetContainer.secondsNoInvoice + timesheetContainer.secondsToInvoice
    )
}
